// extracted by mini-css-extract-plugin
module.exports = {"dot":"RU4q4Ddk"};